import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function AdminReview() {
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState({});

  const load = () => api.get("/admin/review-queue").then((r) => setItems(r.data.items || []));
  useEffect(() => { load(); }, []);

  const resolve = async (id) => {
    try {
      await api.post(`/admin/review-queue/${id}/resolve`, { sonuc_notu: notes[id] || "" });
      toast.success("Doğrulandı olarak işaretlendi");
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-4xl" data-testid="admin-review-page">
      <h1 className="font-head text-2xl font-bold text-slate-900 mb-1">Kontrol Bekleyenler</h1>
      <p className="text-sm text-slate-500 mb-6">Doğrulanması gereken ürün bilgileri. Veriler tahminle değiştirilmez.</p>
      {items.length === 0 && <p className="text-slate-500" data-testid="review-empty">Kontrol bekleyen kayıt yok.</p>}
      <div className="space-y-4">
        {items.map((p) => (
          <div key={p.urun_id} className="bg-white border rounded-xl p-5" data-testid={`review-item-${p.urun_id}`}>
            <div className="flex items-center gap-2 flex-wrap">
              <Badge variant="outline" className="font-mono">{p.urun_kodu}</Badge>
              <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">{p.yonetici_kontrol?.konu}</Badge>
            </div>
            <h3 className="font-semibold text-slate-900 mt-2">{p.urun_adi_tr}</h3>
            <p className="text-xs text-slate-500">Marka: {p.marka} · Tedarikçi: {p.tedarikci || "—"}{p.cas_no ? ` · CAS: ${p.cas_no}` : ""}</p>
            <p className="text-sm text-slate-700 mt-3 bg-amber-50 border border-amber-100 rounded p-3">{p.yonetici_kontrol?.not}</p>
            {p.kaynak_teknik_tanim && (
              <pre className="text-xs text-slate-600 bg-slate-50 rounded p-3 mt-2 whitespace-pre-wrap font-sans">{p.kaynak_teknik_tanim}</pre>
            )}
            <Textarea placeholder="Doğrulama notu (ör. kaynak belge)" value={notes[p.urun_id] || ""}
              onChange={(e) => setNotes({ ...notes, [p.urun_id]: e.target.value })}
              className="mt-3 text-sm" data-testid={`review-note-${p.urun_id}`} />
            <Button size="sm" className="mt-2 bg-teal-600 hover:bg-teal-700" onClick={() => resolve(p.urun_id)}
              data-testid={`review-resolve-${p.urun_id}`}>Doğrulandı olarak işaretle</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
